import { createSlice } from "@reduxjs/toolkit";

import {
  createCustomer,
  updateCustomer,
  createContact,
  getCountries,
  getStates,
  getCities
} from "./actions"
import { setSubscriptionPlan, getToken } from "../actions"

const initialState = {
  loadedFirstTime: false,
  loading: false,
  redirect: false,
  subscriptionPlan: [],
  user:{},
  contact: {},
  email: "",
  customerCreated: false,
  contactCreated: false,
  customerUpdated: false,
  contactUpdated: false,
  tokenCreated: false,
  redirect: false,
  target: "",

  countries: [],
  countriesRequested: false,
  countriesObtained: false,
  states: [],
  statesRequested: false,
  cities: [],
  citiesRequested: false
};

const signUpSlice = createSlice({
  name: "signUp",
  initialState: initialState,
  reducers: {
    resetSignUp: () => initialState,
    setEmail: (state, action) => {
      state.email = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(setSubscriptionPlan, (state, action) => {
      state.subscriptionPlan = action.payload;
    });

    builder.addCase(createCustomer.fulfilled, (state, action) => {
      state.user = action.payload.success ? action.payload.data : {};
      state.customerCreated = action.payload.success ? true : false;
      state.loading = false;
    });
    builder.addCase(createCustomer.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(createCustomer.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(createContact.fulfilled, (state, action) => {
      state.contact = action.payload && action.payload.success ? action.payload.data:{};
      state.contactCreated = true;
      state.loading = false;
    });
    builder.addCase(createContact.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(createContact.rejected, (state, action) => {
      state.contact = action.payload && action.payload.success ? action.payload.data : {};
      state.loading = false;
      state.contactCreated = true;
    });

    builder.addCase(updateCustomer.fulfilled, (state, action) => {
      state.user = action.payload;
      state.customerUpdated = true;
      state.loading = false;
    });
    builder.addCase(updateCustomer.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateCustomer.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getToken.fulfilled, (state, action) => {
      state.loading = false;
      state.redirect = true; //create Token
      state.target = "/payment"; //create Token
    })
    builder.addCase(getToken.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(getToken.rejected, (state) => {
      state.loading = false;
    })

    builder.addCase(getCountries.pending, (state) => {
      state.countriesRequested = true
    })
    builder.addCase(getCountries.fulfilled, (state, action) => {
      state.countriesObtained = action.payload.success ? true : false;
      state.countries = action.payload.success ? action.payload.data : [];
    })
    builder.addCase(getCountries.rejected, (state, action) => {
    })

    builder.addCase(getStates.pending, (state) => {
      state.statesRequested = true;
    })
    builder.addCase(getStates.fulfilled, (state, action) => {
      state.states = action.payload.success ? action.payload.data : [];
      state.statesRequested = false;
    })
    builder.addCase(getStates.rejected, (state) => {
      state.statesRequested = false;
    })

    builder.addCase(getCities.pending, (state) => {
      state.citiesRequested = true;
    })
    builder.addCase(getCities.fulfilled, (state, action) => {
      state.cities = action.payload.success ? action.payload.data : [];
      state.citiesRequested = false;
    })
    builder.addCase(getCities.rejected, (state, action) => {
      state.citiesRequested = false;
    })
  }
});

export const { setEmail, resetSignUp, setCustomerUpdated } = signUpSlice.actions;
export default signUpSlice.reducer;